import classNames from 'classnames';
import React, { CSSProperties, FC, ReactNode } from 'react';
import styled, { Interpolation } from 'styled-components';

interface ModalWithDrawerProps {
    drawer: ReactNode;
    modal: ReactNode;
    open: boolean;
    className?: string;
    classes?: {
        root?: string;
        content?: string;
    };
    styles?: Interpolation<CSSProperties>;
}

interface ModalWithDrawerStyledProps {
    styles?: Interpolation<CSSProperties>;
}

const ModalWithDrawerContainer = styled.div<ModalWithDrawerStyledProps>`
    position: fixed;
    z-index: 10000;
    ${({ styles }) => styles};
`;

const ModalWithDrawerBackdrop = styled.div`
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    z-index: -1;
    position: fixed;
    align-items: center;
    justify-content: center;
    -webkit-tap-highlight-color: transparent;
    ${({ theme: { colors } }) => `
        background-color: ${colors.background.overlay.v5};
    `}
`;

const ModalWithDrawer: FC<ModalWithDrawerProps> = ({
    drawer,
    modal,
    className,
    classes,
    styles,
    open,
}) => {
    return open ? (
        <ModalWithDrawerContainer
            className={classNames('drawer', className, classes && classes.root && classes.root)}
            styles={styles}
        >
            <ModalWithDrawerBackdrop
                aria-hidden="true"
                style={{ opacity: 1, transition: 'opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms' }}
            />
            {drawer}
            {modal}
        </ModalWithDrawerContainer>
    ) : (
        <></>
    );
};

export default ModalWithDrawer;
